/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Yup from 'yup'

// Assets
import { ArrowUpIcon } from 'assets/images/Icons'
// Store
import { actions } from 'core/store'

// Styled Elements
import { Wrapper, Container, Title, RowWrapper, RowContainer, ColContainer, Text } from './AICatalystInput.elements'

// Views
import { Form, FormTextField, Button } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AICatalystInput(props) {
  // Destructure
  const { onSubmit, centered, title, description, prompts, disabled } = props
  console.log(disabled)

  // Ref
  const formRef = useRef()

  // Variables
  const initialFormValues = {
    message: '',
  }
  const validationSchema = Yup.object().shape({
    message: Yup.string(),
  })

  // Functions
  const handleDefaultSubmit = (msg) => {
    formRef.current.message = msg
    onSubmit(formRef.current)
  }

  return (
    <Wrapper centered={centered}>
      <ColContainer style={{ gap: '42px', width: '100%' }}>
        {centered && (
          <RowContainer>
            <ColContainer style={{ gap: '8px' }}>
              <Title>{title || 'AI Catalyst'}</Title>
              {description && <Text>{description}</Text>}
            </ColContainer>
          </RowContainer>
        )}
        <Form
          style={{ width: '100%' }}
          formRef={formRef}
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={(v, { resetForm }) => {
            if (!disabled) {
              onSubmit(v)
              resetForm()
            }
          }}
        >
          <Container>
            <FormTextField name="message" placeholder="Ask Anything" disabled={disabled} />
            <Button variant="outlined" disabled={disabled}>
              <ArrowUpIcon />
            </Button>
          </Container>
        </Form>
        {centered && (
          <RowWrapper>
            {prompts &&
              prompts?.map((text, i) => (
                <Button
                  size="small"
                  key={i}
                  variant="outlined"
                  onClick={() => {
                    if (!disabled) handleDefaultSubmit(text)
                  }}
                >
                  {text}
                </Button>
              ))}
            {!prompts && (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleDefaultSubmit('What is Travel Rule Atlas?')}
                >
                  What is Travel Rule Atlas?
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleDefaultSubmit('How are self-hosted wallets handled?')}
                >
                  How are self-hosted wallets handled?
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleDefaultSubmit('What are the Travel Rule thresholds?')}
                >
                  What are the Travel Rule thresholds?
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleDefaultSubmit('What Travel Rule data must be collected?')}
                >
                  What Travel Rule data must be collected?
                </Button>
              </>
            )}
          </RowWrapper>
        )}
      </ColContainer>
    </Wrapper>
  )
}

// Default Props
AICatalystInput.defaultProps = {
  onSubmit: () => {},
  centered: false,
  disabled: false,
}

// Proptypes Validation
AICatalystInput.propTypes = {
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  prompts: PropTypes.arrayOf(PropTypes.string),
  centered: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(AICatalystInput)
